import { createAsyncThunk } from '@reduxjs/toolkit';
import { ApplicationDataApi, DataForPatchingExtendedIdentityCheck } from 'api/ApplicationDataApi';

import { ErrorResponse } from './ErrorResponse';

export const createExtendedIdentityCheckThunk = (api: ApplicationDataApi) =>
  createAsyncThunk(
    '/application/extendedIdentityCheck',
    async (data: DataForPatchingExtendedIdentityCheck, thunkApi) => {
      try {
        return await api.patchExtendedIdentityCheck(data);
      } catch (error: unknown) {
        thunkApi.rejectWithValue((error as ErrorResponse).response.data);

        throw error;
      }
    },
  );
